import { requestDelete, requestGet, requestPost, requestPut } from '../../../modules/request/index';
import { languageToLocale } from '../../Shared';
import { ConceptFeedback, ConceptFeedbackCollection } from '../interfaces';

class ConceptFeedbackApi {
  private baseUrl: string;

  constructor(public type: string) {
    this.baseUrl = `${window.postbuildEnv.DEFAULT_URL}/api/v1/activity_type/${this.type}/concept_feedback`;
  }

  getAll(language?: string): Promise<ConceptFeedbackCollection> {
    const languageString = language ? `/translations/${languageToLocale[language]}` : '';
    return requestGet(`${this.baseUrl}${languageString}.json`, null, error => { throw error });
  }

  get(uid: string): Promise<ConceptFeedback> {
    return requestGet(`${this.baseUrl}/${uid}.json`, null, error => { throw error });
  }

  create(data: ConceptFeedback): Promise<ConceptFeedback> {
    return requestPost(`${this.baseUrl}.json`, { concept_feedback: data }, null, error => { throw error });
  }

  update(uid: string, data: ConceptFeedback): Promise<ConceptFeedback> {
    return requestPut(`${this.baseUrl}/${uid}.json`, { concept_feedback: data }, null, error => { throw error });
  }

  remove(uid: string): Promise<string> {
    return requestDelete(`${this.baseUrl}/${uid}.json`, null, null, error => { throw error });
  }
}

export { ConceptFeedbackApi };

